const typesActionsRaports = {
  ADDITIONAL_DOCUMENT: 'ADDITIONAL_DOCUMENT',
  EDIT_RAPORT: 'EDIT_RAPORT',
  ADD_RAPORT: 'ADD_RAPORT',
  ADD_FOLLOWUP: 'ADD_FOLLOWUP',
  ADD_ARCHIVE: 'ADD_ARCHIVE',
  REPORT_PERMISSIONS: 'REPORT_PERMISSIONS'
};

type typeActionRaport = string;

export { typesActionsRaports };
export type { typeActionRaport };
